import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";
// react-snap prerenders each route to static HTML at build time, then this
// same bundle hydrates over that markup on load instead of a blank re-render
// (a plain createRoot().render() on top of prerendered DOM would work visually
// but skips hydration, throwing away the server-rendered markup and losing
// its SEO/perf benefit — hasChildNodes() is react-snap's documented signal
// that the root already contains prerendered content).
const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
